/**
 *
 */
/*                                  */
import type { KebabCasedProperties } from "type-fest";

export const props = {
  "name": {
    "type": "string",
    "required": true,
    "prop": "name",
    "desc": "The name of the custom input element. This can be used to identify the input element when submitting a form."
  },
  "value": {
    "type": "string | undefined",
    "required": false,
    "prop": "value",
    "desc": "The value to submit if checked.\n\nIf set as an attribute, this is the reset value for a form reset.\n\nIf the value attribute was omitted, the default value for the checkbox is on, so the submitted data in that case would be `subscribe=on.",
    "default": "\"on\""
  },
  "checked": {
    "type": "boolean | undefined",
    "required": false,
    "prop": "checked",
    "desc": "Whether the radio button is initially checked or not"
  },
  "variant": {
    "type": "\"error\" | \"default\" | undefined",
    "required": false,
    "prop": "variant",
    "desc": "Specifies the visual style variant of the custom input element.",
    "default": "\"default\""
  },
  "disabled": {
    "type": "boolean | undefined",
    "required": false,
    "prop": "disabled",
    "desc": "If set to true, the input element will be disabled, preventing user interaction and input."
  },
  "internals": {
    "type": "ElementInternals",
    "required": true,
    "prop": "internals",
    "desc": ""
  },
  "input-tab-index": {
    "type": "0 | -1 | undefined",
    "required": false,
    "prop": "inputTabIndex",
    "desc": ""
  }
};
export const events = {};
export const slots = {
  "default": {
    "required": true,
    "desc": "**Mandatory for accessibility!**<br />The label for the radio button element.<br />It provides a brief description of the input field, making it easier for users to understand its purpose."
  }
};
export const name = "RadioButtonV1";
export const desc = "The radio button component\n\n```html\n<oc-radio-button-v1 value=\"otto\" name=\"brand\">Otto</oc-radio-button-v1>\n```";
export const tag = "oc-radio-button-v1";

export type Type = import("./RadioButtonV1.svelte").default;
export type Props = import("./RadioButtonV1.svelte").RadioButtonV1Props;
export type Events = import("./RadioButtonV1.svelte").RadioButtonV1Events;
export type Slots = import("./RadioButtonV1.svelte").RadioButtonV1Slots;

type Expand<T> = { [P in keyof T]: T[P] };
/*                                                      */
export type Args = KebabCasedProperties<Props & { [P in keyof Slots]: string }>;
  